import React, { useState, useEffect } from 'react'
import Button from '../../Components/Button/Button'
import Modal from '../../Components/Modal'
import History from '../../Components/History'
import classNames from 'classnames'
import styles from '../../../CSS/main.css'

interface IModalAddProps {
  open: boolean
  textEdit?: string
  onClose: () => void
  onSuccess: (filterWords: string) => void
}

const ModalAdd: React.VFC <IModalAddProps>= ({ open, onClose, textEdit, onSuccess}) => {
  const [filterWords, setFilterWords] = useState<string>()
  const [msgError, setMsgError] = useState<string>()

  useEffect(() => {
    setFilterWords(textEdit)
  }, [textEdit])

  const handleChange = (filterWords: string) => {
    setMsgError(null)
    setFilterWords(filterWords)
  }

  const handleClose = () => {
    setFilterWords(null)
    setMsgError(null)
    onClose()
  }

  const handleEditAdd = () => {
    if (!filterWords) {
      setMsgError("Please enter a forbidden word")
      return
    }
    onSuccess(filterWords)
    handleClose()
  }

  return (
    <Modal open={open} onClose={handleClose} title={textEdit ? "Edit Forbidden word" : "Add Forbidden word"}>
      {msgError && <p className={classNames([styles.MsgAddFilterWord])}>{msgError}</p>}
      <input
        style={{ fontWeight: "normal" }}
        onChange={(e) => handleChange(e.target.value)}
        type='text'
        placeholder='Forbidden Word'
        value={filterWords ?? ""}
      />
      <div
        className={classNames([styles.ButtonBlock, styles.ButtonBlockRight])}>
        <Button additionalClassNames={[styles.ButtonActive]} onClick={handleEditAdd}>
          {textEdit ? "Update" : "Create"}
        </Button>
        <Button onClick={handleClose}>Cancel</Button>
      </div>
    </Modal>
  )
}

export default ModalAdd
